import { splitObject } from '@gettactic/helpers/src/objects/splitObject';
import {
  FormControlWrapperForwardedProps,
  FormControlWrapperProps
} from './defines';

export function splitFormControlWrapperProps<T extends FormControlWrapperProps>(
  props: T
) {
  return splitObject(props, FormControlWrapperForwardedProps);
}
